import React from 'react';

import styles from './component.module.scss';

export const InfoCard = ({
  records
}: {
  records: {
    label: React.ReactNode;
    labelTooltip?: React.ReactNode;
    value: React.ReactNode;
    copyable?: boolean;
  }[];
}) => {
  return (
    <div className={styles.main}>
      {records.map((record, idx) => (
        <div key={idx} className={styles.record}>
          <span className={styles.label}>{record.label}</span>
          <span className={styles.value}>{record.value}</span>
        </div>
      ))}
    </div>
  );
};
